import { isClientContext } from '@/lib/auth/tokenManager';
import { isPostHogEnabled, posthog } from './config';

/**
 * Explicit client-portal funnel events.
 *
 * Autocapture already records masked clicks/pageviews; add an event here
 * only for a milestone worth building a funnel or insight on. Keep names
 * snake_case and prefixed with `client_` so they group cleanly in PostHog.
 */
export type ClientAnalyticsEvent =
  | 'client_login_completed'
  | 'client_document_uploaded'
  | 'client_signature_completed'
  | 'client_questionnaire_submitted';

/**
 * Capture a client-portal analytics event.
 *
 * No-op when PostHog is disabled (dev without debug flag, missing key) or
 * outside the client area. NEVER pass PII or tax data (names, SSNs, EINs,
 * amounts, file names) in properties — counts, booleans, and enum-like
 * strings only.
 *
 * @example
 * captureClientEvent('client_document_uploaded', { file_count: 2 });
 */
export function captureClientEvent(
  event: ClientAnalyticsEvent,
  properties?: Record<string, string | number | boolean | null>
): void {
  if (!isPostHogEnabled() || !isClientContext()) {
    return;
  }
  posthog.capture(event, properties);
}
